import React, { useContext, useState } from "react";
import { Button, Menu, MenuItem, Tooltip } from "@material-ui/core"; // Adicione Tooltip para acessibilidade
import LanguageIcon from "@material-ui/icons/Language"; // 1. Importe o ícone do globo

import { i18n, clearLanguageCache } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import toastError from "../../errors/toastError";
import api from "../../services/api";

const UserLanguageSelector = () => {
    const [langueMenuAnchorEl, setLangueMenuAnchorEl] = useState(null);

    const { user } = useContext(AuthContext);

    const handleOpenLanguageMenu = e => {
        setLangueMenuAnchorEl(e.currentTarget);
    };

    const handleCloseLanguageMenu = () => {
        setLangueMenuAnchorEl(null);
    };

    const handleChangeLanguage = async language => {
        try {
            clearLanguageCache(); // Limpiar cache antes de cambiar idioma
            await i18n.changeLanguage(language);
            await api.put(`/users/${user.id}`, { language });
            window.location.reload(); // Recargar la página para aplicar cambios
        } catch (err) {
            toastError(err);
        }

        handleCloseLanguageMenu();
    };

    return (
        <>
            {/* 2. Adicione um Tooltip para indicar a função do ícone */}
            <Tooltip title={i18n.t("mainHeader.buttons.language")} arrow>
                <Button
                    color="inherit"
                    onClick={handleOpenLanguageMenu}
                    style={{ color: 'white' }}
                >
                    {/* 3. Substitua o texto pelo ícone */}
                    <LanguageIcon />
                </Button>
            </Tooltip>
            <Menu
                anchorEl={langueMenuAnchorEl}
                keepMounted
                open={Boolean(langueMenuAnchorEl)}
                onClose={handleCloseLanguageMenu}
            >
                <MenuItem onClick={() => handleChangeLanguage("es")}>
                    {i18n.t("languages.es")}
                </MenuItem>
                <MenuItem onClick={() => handleChangeLanguage("en")}>
                    {i18n.t("languages.en")}
                </MenuItem>
            </Menu>
        </>
    );
};

export default UserLanguageSelector;
